module.exports = {
    // Header and navigation
    search: {
        en: "Search",
        cy: "Chwiliwch"
    },

    noSearchResults: {
        en: "No results match your search",
        cy: "Dim canlyniadau"
    },

    // Miscellaneous
    readMore: {
        en: "Read more",
        cy: "Darllen mwy"
    },

    noResults: {
        en: "No results to show",
        cy: "Dim canlyniadau i'w dangos"
    },

    backHome: {
        en: "Back home",
        cy: "Yn ôl adref"
    },

    notFoundTitle: {
        en: "Page not found",
        cy: "Tudalen heb ei chanfod"
    },

    notFoundText: {
        en: "The page you are looking for has been moved or does not exist.",
        cy: "Mae'r dudalen yr ydych yn chwilio amdani wedi'i symud neu nid yw'n bodoli."
    },

    // Feedback form
    feedbackSections: {
        en: "Feedback sections",
        cy: "Adrannau adborth"
    },

    required: {
        en: "Required",
        cy: "Angenrheidiol"
    },

    charactersRemaining: {
        en: "Characters remaining",
        cy: "Cymeriadau ar ôl"
    },

    complete: {
        en: "Complete",
        cy: "Cyflawn"
    },

    enterFeedback: {
        en: "Enter your feedback",
        cy: "Rhowch eich adborth"
    },

    back: {
        en: "Back",
        cy: "Yn ol"
    },

    continue: {
        en: "Continue",
        cy: "Parhau"
    },

    save: {
        en: "Save",
        cy: "Arbed"
    },

    noResponse: {
        en: "You didn't provide a response",
        cy: "Ni wnaethoch roi ymateb"
    },

    submitFeedback: {
        en: "Submit feedback",
        cy: "Cyflwyno adborth"
    },

    submitting: {
        en: "Submitting",
        cy: "Cyflwyno"
    },

    completeDetailsTitle: {
        en: "Complete details to submit",
        cy: "Manylion cyflawn i'w cyflwyno"
    },

    completeDetailsText: {
        en: "Please complete the contact details section of this feedback form to submit.",
        cy: "Cwblhewch adran manylion cyswllt y ffurflen adborth hon i'w chyflwyno."
    },

    enableCookiesTitle: {
        en: "Enable cookies to submit",
        cy: "Galluogi cwcis i'w cyflwyno"
    },

    enableCookiesText: {
        en: "To complete this form and submit your feedback, the use of cookies must be accepted. This is necessary to enable in order to allow the user to complete a human-only response from a reCAPTCHA. Once accepting the required cookies you will need to refresh this page to submit your feedback.",
        cy: "Er mwyn llenwi'r ffurflen hon a chyflwyno'ch adborth, rhaid derbyn y defnydd o gwcis. Mae hyn yn angenrheidiol er mwyn galluogi'r defnyddiwr i gwblhau ymateb dynol yn unig o reCAPTCHA. Unwaith y byddwch yn derbyn y cwcis gofynnol bydd angen i chi adnewyddu'r dudalen hon i gyflwyno'ch adborth."
    },

    feedbackTooLongTitle: {
        en: "Your feedback is too long",
        cy: "Mae eich adborth yn rhy hir"
    },

    feedbackTooLongText: {
        en: "The responses you have provided have exceeded the maximum size allowed by your browser. If you cannot reduce the length of your answers, please contact us for support on the best way to provide your feedback.",
        cy: "Mae'r ymatebion a ddarparwyd gennych wedi rhagori ar y maint mwyaf a ganiateir gan eich porwr. Os na allwch leihau hyd eich atebion, cysylltwch â ni am gymorth ar y ffordd orau o roi eich adborth."
    },

    feedbackUnavailableTitle: {
        en: "Feedback unavailable",
        cy: "Nid yw adborth ar gael"
    },

    feedbackUnavailableText: {
        en: "Your browser is set to disallow third party cookies which are required for this feedback form to work correctly. Please disable private browsing in your browser or contact us for support.",
        cy: "Mae eich porwr wedi'i osod i wrthod cwcis trydydd parti sy'n ofynnol er mwyn i'r ffurflen adborth hon weithio'n gywir. Analluoga pori preifat yn eich porwr neu cysylltwch â ni am gefnogaeth."
    },

    feedbackClosedTitle: {
        en: "Feedback is now closed",
        cy: "Mae adborth bellach ar gau",
    },

    feedbackClosedText: {
        en: "The feedback window for this consultation is closed.",
        cy: "Mae'r ffenestr adborth ar gyfer yr ymgynghoriad hwn wedi cau."
    },

    feedbackSuccessfulTitle: {
        en: "Feedback successful",
        cy: "Adborth yn llwyddiannus"
    },

    feedbackSuccessfulText: {
        en: "Thank you for submitting your feedback. We will review all your comments alongside other feedback.",
        cy: "Diolch i chi am gyflwyno eich adborth. Byddwn yn adolygu eich holl sylwadau ochr yn ochr ag adborth arall.",
    },

    feedbackSectionsComplete: {
        en: "sections complete",
        cy: "adrannau wedi'u cwblhau"
    },

    feedbackProgressTitle: {
        en: "Feedback progress",
        cy: "Cynnydd adborth"
    },

    reviewFeedback: {
        en: "Review feedback",
        cy: "Adolygu adborth"
    },

    // News
    backToNews: {
        en: "Back to news",
        cy: "Yn ôl i newyddion"
    },

    // Footer
    companyNumber: {
        en: "Company Number",
        cy: "Rhif Cwmni"
    },

    vatNumber: {
        en: "VAT Number",
        cy: "Rhif TAW"
    },

    registeredOffice: {
        en: "Registered Office",
        cy: "Swyddfa Gofrestredig"
    },

    allRightsReserved: {
        en: "All rights reserved",
        cy: "Cedwir pob hawl"
    },

    // Form validation messages
    checkEmailAddressError: {
        en: "Please check your email address",
        cy: "Gwiriwch eich cyfeiriad e-bost"
    },

    requiredCheckboxFieldError: {
        en: "This is a required field",
        cy: "Mae hwn yn faes gofynnol"
    },

    requiredTextFieldError: {
        en: "is a required field",
        cy: "yn faes gofynnol"
    },

    // User dialogues
    dialoguePasteWarning: {
        en: "When copy and pasting, please be sure to double check your answers before submitting.",
        cy: "Wrth gopïo a gludo, gwnewch yn siŵr eich bod yn gwirio'ch atebion ddwywaith cyn eu cyflwyno.",
    },

    dialogueChangeTracker: {
        en: "Information you have entered will not be saved. Are you sure you want to leave this page?",
        cy: "Ni fydd gwybodaeth rydych chi wedi'i rhoi yn cael ei chadw. Ydych chi'n siŵr eich bod am adael y dudalen hon?",
    },

    dialogueErrorNetwork: {
        en: "Unable to connect to the server. Please check your internet connection and try again.",
        cy: "Methu cysylltu â'r gweinydd. Gwiriwch eich cysylltiad rhyngrwyd a rhowch gynnig arall arni."
    },

    dialogueErrorCancelled: {
        en: "Your feedback submission was cancelled before it could complete. This may be due to your internet connection or the page was reloaded.",
        cy: "Cafodd eich cyflwyniad adborth ei ganslo cyn iddo allu ei gwblhau. Gall hyn fod oherwydd eich cysylltiad rhyngrwyd neu fod y dudalen wedi'i hail-lwytho."
    },

    dialogueErrorBadRequest: {
        en: "We couldn't process your request because there seems to be an issue with the information provided. Please check all required fields and try again.",
        cy: "Ni allem brosesu eich cais oherwydd mae'n ymddangos bod problem gyda'r wybodaeth a ddarparwyd. Gwiriwch yr holl feysydd gofynnol a rhowch gynnig arall arni."
    },

    dialogueGenericNetworkError: {
        en: "Sorry, there was an error trying to send your feedback, please check your submission and try again.",
        cy: "Mae'n ddrwg gennym, roedd gwall wrth geisio anfon eich adborth, gwiriwch eich cyflwyniad a rhowch gynnig arall arni."
    },

    dialogueProblemsPersist: {
        en: "If the problem persists contact us on",
        cy: "Os bydd y broblem yn parhau cysylltwch â ni ar"
    },

    // Map search
    mapEnterAddressFieldLabel: {
        en: "Enter Address",
        cy: "Rhowch Cyfeiriad"
    },

    mapEnterAddressFieldPlaceholder: {
        en: "Enter your postcode to see your location on the map",
        cy: "Rhowch eich cod post i weld eich lleoliad ar y map"
    },

    mapEnterAddressButton: {
        en: "Apply",
        cy: "Ymgeisiwch"
    },

    // Map section breakdown
    mapBreakdownButton: {
        en: "Open/Close the activity summary",
        cy: "Agor/Caewch grynodeb y gweithgaredd"
    },

    mapBreakdown: {
        en: "Section breakdown",
        cy: "Dadansoddiad adran"
    },

    mapBreakdownClose: {
        en: "Close section breakdown panel",
        cy: "Caewch y panel dadansoddi adran"
    }
}